import type { CSSProperties } from "react";

export function BcmLogo({ style }: { style?: CSSProperties }) {
  return (
    <div className="bcm-logo-wrap" style={style}>
      <img src="/branding/logo.svg" className="bcm-logo-glow bcm-logo-glow-1" alt="" />
      <img src="/branding/logo.svg" className="bcm-logo-glow bcm-logo-glow-2" alt="" />
      <img src="/branding/logo.svg" className="bcm-logo-glow bcm-logo-glow-3" alt="" />
      <img src="/branding/logo.svg" className="bcm-logo-sharp" alt="Brian Calli Music" />
    </div>
  );
}
